// Copyright (c) 2020 Sagacity Solutions Inc. All right reserved.
'use strict';

import moment from 'moment-timezone';

let availableTimezone = [
  "Europe/Madrid",
  "US/Alaska",
  "US/Aleutian",
  "US/Arizona",
  "US/Central",
  "US/East-Indiana",
  "US/Eastern",
  "US/Hawaii",
  "US/Indiana-Starke",
  "US/Michigan",
  "US/Mountain",
  "US/Pacific",
  "US/Pacific-New",
  "US/Samoa",];

function includeCurrentTz(list ) {
  let g = moment.tz.guess();
  return [g, ...list.filter(x => x != g)];
}
export function getAvailableTimeZone() {
  let tz = includeCurrentTz(availableTimezone);
  return tz.flatMap(function(x) {
    return { value: x, text: x };
  });
}

export function timezoneFilter(f) {
  let list = includeCurrentTz(availableTimezone);
  let tz = list.filter(x => x.toLowerCase().includes(f.toLowerCase()));
  return tz.flatMap(function(x) {
    let pos = x.indexOf('/');
    return { value: x, text: x.substr(pos) };
  });
}
